const styleOverrides = {
  root: {
    padding: 0
  },
  horizontal: {
    alignItems: 'start'
  }
};
export default {
  styleOverrides
};